export default [
    '18 18',
    '<path id="Icon" d="M15.75 15.75H2.25M13.5 8.25L9 12.75M9 12.75L4.5 8.25M9 12.75V2.25" fill="none" stroke="url(#paint0_linear_1302_774)" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>\n' +
        '<defs>\n' +
    '<linearGradient id="paint0_linear_1302_774" x1="31.5" y1="18.0207" x2="4.5" y2="18.0207" gradientUnits="userSpaceOnUse">\n' +
    '<stop stop-color="var(--p-icon-gradient-stop, currentColor)"/>\n' +
    '<stop offset="1" stop-color="var(--p-icon-gradient-start, currentColor)"/>\n' +
    '</linearGradient>\n' +
    '</defs>'
]